import { createActionFactory, Feature, createThunk, ThunkDispatch } from '../../../shared';
import { getPackageState, EditContactOptionsState } from '../../../appstate';
import { getCurrentHubPersonaId } from '../../selectors/currentPersonaSelector';
import { packageStateKey, HubState } from '../../state';

export const personaEditClickedAction = createActionFactory<{
    hubPersonaId: string;
    origin: Origin;
    options?: EditContactOptionsState;
}>('PersonaEditClickedAction', Feature.ContactManagement, action => {
    return {
        origin: action.payload.origin,
        focusPropertyUri: action.payload.options?.focusPropertyUri,
    };
});
export type Origin = 'CommandBar' | 'EV' | 'PDL' | 'HubList' | 'ListIcon';

export const editPersonaClicked = (origin: Origin, options?: EditContactOptionsState) =>
    createThunk('EditPersonClicked', (dispatch: ThunkDispatch, getState: () => {}) => {
        const state = getPackageState<HubState>(getState(), packageStateKey);
        const currentPersonaId = getCurrentHubPersonaId(state.appState, state.packageState);

        dispatch(personaEditClickedAction({ hubPersonaId: currentPersonaId, origin, options }));
    });

export const editPersonaClickedWithPersonaId = (origin: Origin, hubPersonaId: string) =>
    createThunk(
        'EditPersonaClickedWithPersonaId',
        (dispatch: ThunkDispatch, getState: () => {}) => {
            dispatch(personaEditClickedAction({ hubPersonaId: hubPersonaId, origin }));
        }
    );
export type { Action } from '../../../shared';
